<template>
    <div class="adset-summary__row">
        <div class="flex flex-wrap">
            <span class="pipe-item flex items-center" v-for="item in items" :key="item[label]">{{ item[label] }}</span>
        </div>
        <div class="adset-summary__row--type">{{ name }}</div>
    </div>
</template>

<style lang="scss" scoped>
    .pipe-item {
        font-size: 18px;
        color: #4a4a4a;
        line-height: .8;
        margin: 0;
        font-weight: 600;
        padding: 4px 0;

        &:not(:last-child) {
            &::after {
                content: '';
                display: inline;
                width: 2px;
                height: 100%;
                background: #4a4a4a;
                margin: 0 9px;
            }
        }
    }
</style>

<script type="text/babel">
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            items: {
                type: Array,
                required: true
            },
            label: {
                type: String,
                default: 'label'
            }
        }
    }
</script>
